define( function() {
	return ( /<([\w:-]+)/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/manipulation/var/rtagName.js
 ** module id = 856
 ** module chunks = 2
 **/